import { useState } from "react";
import { cn } from "@provenleap/ui";
import { CaretDown } from "@phosphor-icons/react";
import { SectionArrow } from "./SectionArrow";
import { HOMEPAGE_FAQS, type FAQItem } from "../../data/faqs";

const faqs = HOMEPAGE_FAQS;

function FAQAccordionItem({
  item,
  isOpen,
  onToggle,
}: {
  item: FAQItem;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="border-b border-[hsl(213_27%_86%)] last:border-b-0">
      <button
        type="button"
        className="flex w-full items-center justify-between py-4 text-left text-[15px] font-medium text-foreground hover:text-brand transition-colors cursor-pointer"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        {item.question}
        <CaretDown
          size={16}
         
          className={cn(
            "shrink-0 text-muted-foreground transition-transform duration-200",
            isOpen && "rotate-180",
          )}
        />
      </button>
      <div
        className={cn(
          "overflow-hidden transition-all duration-200",
          isOpen ? "max-h-[640px] pb-4" : "max-h-0",
        )}
      >
        <p className="text-[15px] text-foreground/85 leading-relaxed">
          {item.answer}
        </p>
      </div>
    </div>
  );
}

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return (
    <div id="faq" className="pt-8 pb-12 sm:pt-12 sm:pb-14 scroll-mt-20">
      <div className="max-w-[720px] mx-auto px-3 sm:px-8">
        <div className="text-center mb-12">
          <SectionArrow />
          <h2 className="text-2xl sm:text-3xl font-bold text-foreground">
            Frequently asked questions
          </h2>
          <p className="mt-4 text-lg text-foreground/85">
            Everything you need to know about ProvenLeap.
          </p>
        </div>

        <div className="border-t border-[hsl(213_27%_86%)]">
          {faqs.map((faq, index) => (
            <FAQAccordionItem
              key={faq.question}
              item={faq}
              isOpen={openIndex === index}
              onToggle={() =>
                setOpenIndex(openIndex === index ? null : index)
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
}
